import { SpriteView } from '../../ui_canvas_engine/SpriteView.ts';
import { AudioManager, AudioType } from '@colonist/audio';
import { Sprites } from '../UIGameImageDictionary.ts';
import { UIGameSpriteHandler } from '../../UIGameSpriteHandler.ts';
import { Point } from '@colonist/game-mechanic-validators';
import { UIGameExpandContractAnimation } from '../../ui_canvas_engine/animation/UIGameExpandContractAnimation.ts';
export class UIGameMapHighlightView extends SpriteView {
    animate() {
        this.animation.start();
    }
    resetAnimation() {
        this.animation.stop();
    }
    displayOnlyOnHover() {
        const onHoverStart = ()=>this.alpha = 1;
        const onHoverEnd = ()=>this.alpha = 0;
        this.alpha = 0;
        this.setHoverAction(onHoverStart, onHoverEnd);
    }
    displayAlwaysOn(canAffordAction) {
        this.alpha = canAffordAction ? 1 : 0;
    }
    resetDisplay() {
        const revertedHoverAction = ()=>this.alpha = 1;
        this.alpha = 1;
        this.setHoverAction(revertedHoverAction, revertedHoverAction);
    }
    static getTextureForHighlight(isWhite) {
        return isWhite ? UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_highlight_circle_white) : UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_highlight_circle);
    }
    constructor(uiGameManager, parameters, container, action, isWhite = false, shouldHighlightOnlyOnHover = false){
        super(parameters.x, parameters.y, parameters.size, parameters.size, container, UIGameMapHighlightView.getTextureForHighlight(isWhite));
        this.uiGameManager = uiGameManager;
        this.setClickAction(()=>{
            action();
            AudioManager.play(AudioType.Click);
        });
        this.animation = new UIGameExpandContractAnimation(this);
        this.size = parameters.size;
        this.highlightedGameElementIndex = parameters.index;
        this.center = new Point(this.x + this.size / 2, this.y + this.size / 2);
        this.zIndex = this.uiGameManager.mapController.mapView.layers.topLayer;
        if (isWhite) return;
        if (shouldHighlightOnlyOnHover) return;
        this.setHoverAction((event)=>{
            this.texture = UIGameMapHighlightView.getTextureForHighlight(true);
        }, (event)=>{
            this.texture = UIGameMapHighlightView.getTextureForHighlight(false);
        });
    }
}
